export const FishingIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M17.586 11.4142L11.656 17.3442C10.5951 18.405 9.15629 19.001 7.656 19.001C6.15571 19.001 4.71687 18.405 3.656 17.3442C2.59513 16.2833 1.99915 14.8444 1.99915 13.3442C1.99915 11.8439 2.59513 10.405 3.656 9.34415L6.793 6.20715C6.89188 6.10824 7.01786 6.04089 7.15503 6.01359C7.29219 5.9863 7.43437 6.0003 7.56358 6.05383C7.69278 6.10735 7.80321 6.19799 7.8809 6.31428C7.95858 6.43058 8.00003 6.5673 8 6.70715V10.0002"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.4139 8.586L21.9999 7"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19 12C20.1046 12 21 11.1046 21 10C21 8.89543 20.1046 8 19 8C17.8954 8 17 8.89543 17 10C17 11.1046 17.8954 12 19 12Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const WatersportsIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M20.3605 14.0365H3.77907L1.91967 14.1529C1.11169 14.2035 0.695541 15.1431 1.20106 15.7754L3.77907 19.0001H11.8023H19.1895C19.6033 19.0001 20.007 18.8717 20.3448 18.6326L22.6985 16.9669C23.3006 16.5408 23.2499 15.6317 22.6041 15.2752L20.3605 14.0365ZM20.3605 14.0365C20.3605 14.0365 16.1821 11.1919 13.5809 10.7776C13.224 10.7208 12.8904 10.9225 12.7133 11.2374L11.1395 14.0365H20.3605Z"
      stroke="currentColor"
      strokeWidth="1.25"
    />
    <path
      d="M22.5 16.5H16.6163H12.1969C11.9434 16.5 11.6993 16.5963 11.514 16.7695L9.12789 19M4.5 14.0365H8C7.64765 12.121 9.53001 9.50114 10.4975 7.70733C10.8724 7.01221 10.4097 6.84958 9.9498 7.49162C9.23559 8.48868 8.28203 9.78532 7.5 10.7274C6.37768 12.0793 4.5 14.0365 4.5 14.0365Z"
      stroke="currentColor"
      strokeWidth="1.25"
    />
    <path d="M5 10H11" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" />
  </svg>
);

const SailingIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M21.4431 15.6249H19.7559C19.9605 14.8075 20.0729 13.9695 20.0729 13.1214C20.0729 8.34923 16.8315 4.19023 12.1993 3.02529C11.9744 2.96398 11.729 3.01507 11.5449 3.16835C11.3608 3.31142 11.2484 3.53622 11.2484 3.77126V6.47921L5.48121 15.6249H2.56696C2.14771 15.6249 1.80005 15.9724 1.80005 16.3914V18.0264C1.80005 19.6613 3.13958 21 4.77566 21H17.5881C20.1343 21 22.1998 18.9358 22.1998 16.3914C22.2101 15.9622 21.8624 15.6249 21.4431 15.6249ZM17.5881 19.4672H4.77566C3.97807 19.4672 3.33387 18.8234 3.33387 18.0264V17.1578H20.574C20.2365 18.4862 19.0299 19.4672 17.5881 19.4672ZM18.5391 13.1214C18.5391 13.9695 18.4062 14.8075 18.1608 15.6249H12.772V4.81357C16.2077 6.10113 18.5391 9.38132 18.5391 13.1214ZM11.2381 9.35066V15.6249H7.28089L11.2381 9.35066Z"
      fill="currentColor"
    />
  </svg>
);

const CelebratingIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M5.8 11.2998L2 21.9998L12.7 18.2098"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M4 3H4.01" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M22 8H22.01" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M15 2H15.01" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M22 20H22.01" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M22 2L19.76 2.75C19.1224 2.96239 18.5783 3.38964 18.2208 3.95872C17.8633 4.52781 17.7146 5.20339 17.8 5.87C17.9 6.73 17.23 7.5 16.35 7.5H15.97C15.11 7.5 14.37 8.1 14.21 8.94L14 10"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22 12.9999L21.18 12.6699C20.32 12.3299 19.36 12.8699 19.2 13.7799C19.09 14.4799 18.48 14.9999 17.77 14.9999H17"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 2L11.33 2.82C11.67 3.68 11.13 4.64 10.22 4.8C9.52 4.9 9 5.52 9 6.23V7"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 12.9995C12.93 14.9295 13.83 17.1695 13 17.9995C12.17 18.8295 9.93 17.9295 8 15.9995C6.07 14.0695 5.17 11.8295 6 10.9995C6.83 10.1695 9.07 11.0695 11 12.9995Z"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const CruisingIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M12 6V22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M19 13L21 12C21 14.3869 20.0518 16.6761 18.364 18.364C16.6761 20.0518 14.3869 21 12 21C9.61305 21 7.32387 20.0518 5.63604 18.364C3.94821 16.6761 3 14.3869 3 12L5 13"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M9 11H15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M12 6C13.1046 6 14 5.10457 14 4C14 2.89543 13.1046 2 12 2C10.8954 2 10 2.89543 10 4C10 5.10457 10.8954 6 12 6Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default {
  fishing: FishingIcon,
  watersports: WatersportsIcon,
  sailing: SailingIcon,
  celebrating: CelebratingIcon,
  cruising: CruisingIcon,
};
